module.exports = __webpack_public_path__ + "static/media/brent-comber-7464-exhibition.babff39f.png";